import React, { useRef } from 'react';
import Card from '@material-ui/core/Card';
import { isEmpty } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ScoreTable from '../ScoreTable';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PopUpModal from '../../../../../../components/PopUpModal';
import Rank from '../../../../../../assets/PerformanceAnalysisRank.svg';
import InfoIcon from '../../../../../../assets/info-with-circle.svg';
import PropTypes from 'prop-types';
import EPICard from '../EPICard';
import './styles.scss';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%',
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '50%',
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%',
    },
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}));
export default function ScoreCard(props) {
  const childRef = useRef();
  const classes = useStyles();
  const listRank = props.listRank;
  const listSubjectRank = props.listSubjectRank;
  const courseScores = props.courseScores;
  const listJEEScore = props.listJEEScore;

  const parseRankResult = (str) => {
    return str.replace(' out of ', '/');
  };

  const parseSubjectTitle = (str) => {
    let parseDt = str.replace('Overall', '');
    return parseDt.trim().toUpperCase();
  };
  const handleEPIData = () => {
    childRef.current.handleClickOpen();
  };

  const containsEPI = () => {
    if (!isEmpty(listJEEScore)) {
      return listJEEScore.some((item) => item.Criteria.includes('EPI'));
    }
  };

  const populateCardsData = () => {
    const cards = [];
    (props.isFetching ? [1,1,1] : listRank).map((item, index) => {
      cards.push(
        <Grid item xs={12} sm={6} md={6} key={index}>
          <Card className="card score-card-ranks">
            <h3 className="title">{props.isFetching ? <Skeleton width="30%"/> : parseSubjectTitle(item.RankTitle)}</h3>
            <div className="score">
              <div className="icon">
              {props.isFetching ? <Skeleton height="60px" width="60px"/> :
                <img src={Rank} />}
              </div>
              <div className="result">{props.isFetching ? <Skeleton width="70px"/> : parseRankResult(item.RankDetail)}</div>
            </div>
          </Card>
        </Grid>
      );
    });
    return cards;
  };

  const populateSubjectCard = () => {
    const cards = [];
    (props.isFetching ? [1,1,1] :listSubjectRank).map((item, index) => {
      cards.push(
        <TableRow key={index}>
          <TableCell component="th" scope="row">
            {props.isFetching ? <Skeleton width="50%"/> : parseSubjectTitle(item.RankTitle)}
          </TableCell>
          <TableCell align="right" className="ranks">
            {props.isFetching ? <Skeleton width="50%"/> : parseRankResult(item.RankDetail)}
          </TableCell>
        </TableRow>
      );
    });
    return cards;
  };

  const epiHeader = <div>Info</div>;
  const epiBody = (
    <div>
      <EPICard containsEPI={containsEPI()} />
    </div>
  );

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <div className="heading">
            {props.isFetching ? <Skeleton width="20%"/> :
            <h3>Overall Rank</h3>}
          </div>
          <Grid container spacing={2} className="wrap-card-content">
            {(listRank && listRank.length > 0 || props.isFetching) && populateCardsData()}
            {(listSubjectRank && listSubjectRank.length > 0 || props.isFetching ) && (
              <Grid item xs>
                <Card className="card score-card-ranks">
                  <TableContainer className="rank-table">
                    <PerfectScrollbar>
                      <Table size="small">
                        <TableBody>{populateSubjectCard()}</TableBody>
                      </Table>
                    </PerfectScrollbar>
                  </TableContainer>
                </Card>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <div className="heading flex align-center">
          {props.isFetching ? <Skeleton width="20%"/> :
            <h3>Score Card</h3>}
            <span className="sub-head ml-5">
              {props.isFetching ? <Skeleton width="70px"/> : props.paper2 ? '(Paper 1 + Paper 2)' : ''}
            </span>
            <span className="emi-icon ml-auto cursor">
            {props.isFetching ? <Skeleton width="20px" height="20px"/> :
              <img src={InfoIcon} onClick={handleEPIData} />}
            </span>
          </div>
          <Card className="card">
            <ScoreTable courseScores={props.isFetching ? [] : courseScores} isFetching={props.isFetching}/>
          </Card>
        </Grid>
      </Grid>
      <PopUpModal
        ref={childRef}
        header={epiHeader}
        body={epiBody}
        width={classes.dialogCustomizedWidth}
      />
    </React.Fragment>
  );
}

ScoreCard.propTypes = {
  listRank: PropTypes.array,
  listSubjectRank: PropTypes.array,
  courseScores: PropTypes.array,
  paper2: PropTypes.bool,
  listJEEScore: PropTypes.array,
  isFetching: PropTypes.bool
};
